import negativeKeyword from './resource';
import errorTransformer from '../../transformers/errorTransformer';

function addBulkNegativeKeyword({ campaignId, negativeKeywords }) {
  return negativeKeyword
    .addBulkNegativeKeyword(
      {
        itemId: campaignId,
      },
      {
        data: negativeKeywords,
      },
    )
    .then(({ body }) => body)
    .catch(errorTransformer);
}

export default {
  addBulkNegativeKeyword,
};
